/**
 * Wrapper na axios — wszystkie wywołania API KSeF używane w UI konfiguracji.
 *
 * Wyodrębnione z: /app/frontend/src/pages/settings/KsefSettingsPage.jsx
 * (axios calls rozproszone w handlerach fetchAdminConfig/handleSaveNip/handleSaveCert/
 *  handleHealthCheck/handleSync/handleDelete/handleDeletePassword/handleTestMtls/handleMtlsDiagnose).
 *
 * UWAGA: Endpointy backendowe NIE zmienione — dokładnie te same ścieżki co w starej stronie.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const axiosConfig = { withCredentials: true };

// =========================
// Admin config
// =========================
export const getAdminConfig = () =>
  axios.get(`${API}/ksef/admin/config`, axiosConfig);

export const deleteAdminConfig = () =>
  axios.delete(`${API}/ksef/admin/config`, axiosConfig);

// =========================
// NIP
// =========================
export const getSavedNip = () =>
  axios.get(`${API}/ksef/admin/nip`, axiosConfig);

export const saveNip = (companyNip) =>
  axios.post(`${API}/ksef/admin/nip`, { company_nip: companyNip }, axiosConfig);

// =========================
// Storage info
// =========================
export const getStorageInfo = () =>
  axios.get(`${API}/ksef/storage/info`, axiosConfig);

// =========================
// Legacy settings status (kompatybilność)
// =========================
export const getSettingsStatus = () =>
  axios.get(`${API}/ksef/settings/status`, axiosConfig);

// =========================
// Cert upload (legacy — wszystko na raz)
// =========================
export const uploadCertConfig = (formData) =>
  axios.post(`${API}/ksef/admin/config/cert`, formData, {
    ...axiosConfig,
    headers: { "Content-Type": "multipart/form-data" },
  });

// =========================
// Cert / Key / Password — split endpointy (refaktor 2026-06-01)
// Każdy element konfiguracji zapisywany osobno, własnym buttonem "Zapisz".
// =========================
export const uploadCertFile = (file) => {
  const fd = new FormData();
  fd.append("cert_file", file);
  return axios.post(`${API}/ksef/admin/cert/file`, fd, {
    ...axiosConfig,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadKeyFile = (file) => {
  const fd = new FormData();
  fd.append("key_file", file);
  return axios.post(`${API}/ksef/admin/key/file`, fd, {
    ...axiosConfig,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const saveKeyPassword = (keyPassword) =>
  axios.post(
    `${API}/ksef/admin/cert/password`,
    { key_password: keyPassword },
    axiosConfig,
  );

export const validateCertKeyPair = () =>
  axios.get(`${API}/ksef/admin/cert/validate-pair`, axiosConfig);

export const runFullDiagnostics = () =>
  axios.post(`${API}/ksef/admin/diagnose-full`, {}, axiosConfig);

export const deleteKeyPassword = () =>
  axios.delete(`${API}/ksef/admin/cert/password`, axiosConfig);

// =========================
// Health check
// =========================
export const runHealthCheck = () =>
  axios.post(`${API}/ksef/admin/health`, {}, axiosConfig);

// =========================
// mTLS Test / Diagnose
// =========================
export const runMtlsTest = () =>
  axios.post(`${API}/ksef/mtls-test`, {}, axiosConfig);

export const runMtlsDiagnose = () =>
  axios.post(`${API}/ksef/mtls-diagnose`, {}, axiosConfig);

// =========================
// Sync (legacy admin/sync/run)
// =========================
export const runAdminSync = (daysBack, maxDocs = 50) =>
  axios.post(`${API}/ksef/admin/sync/run`, null, {
    ...axiosConfig,
    params: { days_back: daysBack, max_docs: maxDocs },
  });
